import React from "react";
import { StyledOrderMoreThanAllocationAlert } from "./index.styled";

export const OrderMoreThanAllocationAlert = () => {
  return (
    <StyledOrderMoreThanAllocationAlert
      type="warning"
      closable
      title="Order is more than your allocation amount"
    >
      Please pay by another payment method or lower your order amount.
    </StyledOrderMoreThanAllocationAlert>
  );
};
